import React, { useState, useEffect } from "react";
import { ProjectsList } from "../../components";
import ProjectDetails from "../../components/projects-list/project-detail/ProjectDetails";
import { translate } from "../../../../common/providers";
import { CustomIconButton, icon, SingleFieldDialog, SidePanel } from "../../../../common/components";
import styles from "./AdminProject.module.css";

export default function AdminProject({
	selectedCompany,
	getCompanyProjects,
	onChangeArchive,
	onChangeName,
	companyIdToProject,
}) {
	const [selectedProject, setSelectedProject] = useState(null);
	const [openRenameDialog, setOpenRenameDialog] = useState(false);

	useEffect(() => {
		if (selectedCompany) {
			getCompanyProjects({ company: selectedCompany });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedCompany]);

	const handleSelectProject = ({ project }) => {
		setSelectedProject(project !== selectedProject ? project : null);
	};

	const handleArchive = ({ project }) => {
		if (!project || !selectedCompany) {
			return;
		}
		onChangeArchive({
			companyId: selectedCompany.id,
			projectId: project.id,
			name: project.name,
			status: project.currentStatus === "ACTIVE" ? "ARCHIVED" : "ACTIVE",
		});
	};

	const handleDialogRename = ({ project } = {}) => {
		if (project) {
			setSelectedProject(project);
		}
		setOpenRenameDialog((prev) => !prev);
	};

	const handleRename = (newName) => {
		onChangeName({
			companyId: selectedCompany.id,
			projectId: selectedProject.id,
			name: newName,
			status: selectedProject.currentStatus,
		});
	};

	return (
		<>
			<div className={styles["middle-panel"]}>
				<ProjectsList
					projects={companyIdToProject}
					selectedProject={selectedProject}
					onChangeArchive={handleArchive}
					onChangeName={handleDialogRename}
					onClickRow={handleSelectProject}
				/>
			</div>
			<SidePanel open={!!selectedProject} size={35} onClose={() => setSelectedProject(null)}>
				<div className={styles.drawer}>
					<div className={styles.drawer__header}>
						<span className={styles.drawer__title}>
							{translate("admin.project-details.drawer.title", { name: selectedProject?.name })}
						</span>
						<CustomIconButton icon={icon.faTimes} onClick={() => setSelectedProject(null)} />
					</div>
					<div className={styles.drawer__content}>
						<ProjectDetails companyId={selectedCompany?.id} project={selectedProject} />
					</div>
				</div>
			</SidePanel>
			<SingleFieldDialog
				label={translate("admin.project.save-dialog.file.label")}
				open={openRenameDialog}
				submitLabel={translate("admin.project.save-dialog.title.rename")}
				title={translate("admin.project.save-dialog.title.rename")}
				value={selectedProject?.name}
				onClose={handleDialogRename}
				onSubmit={handleRename}
			/>
		</>
	);
}
